/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Loader, Modal } from 'semantic-ui-react';
import { toJS } from 'mobx';
import { withTranslation } from 'react-i18next';
import cx from 'classnames';
import api from '../../api';
import ClarLoader from '../Loader/Loader';
import WithRouter from '../Extensions/WithRouter';

class System extends Component {
  constructor(props) {
    super(props);
    this.modalBody = '';
    this.modalAction = '';
    this.modalSubBody = '';
    this.state = {
      isLoading: false,
      isOtherLoading: false,
      isGlobalErrorLoading: false,
      isModalLoading: false,
      isModalErrorLoading: false,
      isOssLoading: false,
      isOssDetailLoading: false,
      isOssGlobalErrorLoading: false,
      isOssModalLoading: false,
      isOssModalErrorLoading: false,
      errorMsg: '',
      ossErrorMsg: '',
      selectedDB: '',
      otherHost: '',
      customHost: '',
      port: '',
      database: '',
      userName: '',
      password: '',
      selectedOssDB: '',
      otherOssHost: '',
      customOssHost: '',
      ossPort: '',
      ossDatabase: '',
      ossUserName: '',
      ossPassword: '',
      otherHostError: false,
      customHostError: false,
      portError: false,
      databaseError: false,
      userNameError: false,
      passwordError: false,
      otherOssHostError: false,
      customOssHostError: false,
      ossPortError: false,
      ossDatabaseError: false,
      ossUserNameError: false,
      ossPasswordError: false,
      isOpenAlertModal: false,
      isOpenModal: false,
      isOpenOssModal: false,
      isAutoCompleteName: false,
      isAutoCompletePass: false,
      isAutoCompleteOssName: false,
      isAutoCompleteOssPass: false,
      isOtherHostFocus: false,
      isCustomHostFocus: false,
      isOtherOssHostFocus: false,
      isCustomOssHostFocus: false,
      isCampLoading: false,
      isCampDetailLoading: false,
      selectedCampDB: '',
      isCampGlobalErrorLoading: false,
      campErrorMsg: '',
      campScheme: 'http',
      customCampHost: '',
      isCustomCampHostFocus: false,
      customCampHostError: false,
      campPort: '',
      campPortError: false,
      isOpenCampModal: false,
      isCampModalLoading: false,
      isCampModalErrorLoading: false,
      isjobCountLoading: false,
      isJobCountGlobalErrorLoading: false,
      jobCountErrorMsg: '',
      jobCount: 1,
      jobCountError: false,
      isOpenJobModal: false,
      isJobModalLoading: false,
      isJobModalErrorLoading: false,
      isPageLoading: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onSubmitWithOss = this.onSubmitWithOss.bind(this);
    this.onSubmitWithCamp = this.onSubmitWithCamp.bind(this);
    this.onSubmitWithJobCount = this.onSubmitWithJobCount.bind(this);
    this.setUserDBSettings = this.setUserDBSettings.bind(this);
    this.setOssDBSettings = this.setOssDBSettings.bind(this);
    this.setCampSettings = this.setCampSettings.bind(this);
    this.setJobCountSettings = this.setJobCountSettings.bind(this);
    this.handleCustomHostChange = this.handleCustomHostChange.bind(this);
    this.handleOtherHostChange = this.handleOtherHostChange.bind(this);
    this.handlePortChange = this.handlePortChange.bind(this);
    this.handleDBChange = this.handleDBChange.bind(this);
    this.handleUserNameChange = this.handleUserNameChange.bind(this);
    this.handlePWChange = this.handlePWChange.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleUserNameFocus = this.handleUserNameFocus.bind(this);
    this.handlePWFocus = this.handlePWFocus.bind(this);
    this.handleOssTabChange = this.handleOssTabChange.bind(this);
    this.handleOssOtherHostChange = this.handleOssOtherHostChange.bind(this);
    this.handleOssCustomHostChange = this.handleOssCustomHostChange.bind(this);
    this.handleOssPortChange = this.handleOssPortChange.bind(this);
    this.handleOssDBChange = this.handleOssDBChange.bind(this);
    this.handleOssUserNameChange = this.handleOssUserNameChange.bind(this);
    this.handleOssUserNameFocus = this.handleOssUserNameFocus.bind(this);
    this.handleOssPWChange = this.handleOssPWChange.bind(this);
    this.handleOssPWFocus = this.handleOssPWFocus.bind(this);
    this.handleCustomHostFocus = this.handleCustomHostFocus.bind(this);
    this.handleOtherHostFocus = this.handleOtherHostFocus.bind(this);
    this.handleOssCustomHostFocus = this.handleOssCustomHostFocus.bind(this);
    this.handleOssOtherHostFocus = this.handleOssOtherHostFocus.bind(this);
    this.handleCampTabChange = this.handleCampTabChange.bind(this);
    this.handleCampSchemeChange = this.handleCampSchemeChange.bind(this);
    this.handleCampCustomHostFocus = this.handleCampCustomHostFocus.bind(this);
    this.handleCampCustomHostChange = this.handleCampCustomHostChange.bind(this);
    this.handleCampPortChange = this.handleCampPortChange.bind(this);
    this.onSubmitWithCamp = this.onSubmitWithCamp.bind(this);
    this.handleJobCountChange = this.handleJobCountChange.bind(this);
    this.onSubmitWithJobCount = this.onSubmitWithJobCount.bind(this);
    this.validation = this.validation.bind(this);
    this.ossValidation = this.ossValidation.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.onUpdateLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;
    const { location, state } = this.props;
    const {
      systemObj,
    } = state.company;

    if (prevProps.location && location) {
      const currentPath = location.pathname ? location.pathname : location;
      const prevPath = prevProps.location.pathname ? prevProps.location.pathname : prevProps.location;
      if (currentPath !== prevPath) {
        this.requiredAdmin();
      }
    }

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      if (systemObj && systemObj.ui_db) {
        this.getUserDBSettings();
      }
      if (systemObj && systemObj.oss_db) {
        this.getOssDBSettings();
      }
      if (systemObj && systemObj.camp) {
        this.getCampSettings();
      }
      if (systemObj && systemObj.job_count) {
        this.getJobCountSettings();
      }

      if (Object.keys(toJS(systemObj)).length === 0) {
        this.onUpdateFetchData();
      }
      this.setState({
        isPageLoading: false,
      });
    }
  }

  componentWillUnmount() {
  }

  handleCustomHostChange(event) {
    this.setState({
      customHostError: false,
      customHost: event.target.value,
    });
  }

  handleOtherHostChange(event) {
    this.setState({
      otherHostError: false,
      otherHost: event.target.value,
    });
  }

  handlePortChange(event) {
    this.setState({
      portError: false,
      port: event.target.value,
    });
  }

  handleDBChange(event) {
    this.setState({
      databaseError: false,
      database: event.target.value,
    });
  }

  handleUserNameChange(event) {
    this.setState({
      userNameError: false,
      userName: event.target.value,
    });
  }

  handlePWChange(event) {
    this.setState({
      passwordError: false,
      password: event.target.value,
    });
  }

  handleUserNameFocus() {
    this.setState({
      isAutoCompleteName: true,
    });
  }

  handlePWFocus() {
    this.setState({
      isAutoCompletePass: true,
    });
  }

  handleTabChange(e) {
    const target = e.target.text;
    const { selectedDB } = this.state;
    const { t } = this.props;
    let textEn;

    if (target === t('system.title.default')) {
      textEn = 'Default';
    }
    if (target === t('system.title.other_clarity_system')) {
      textEn = 'Other Clarity System';
    }
    if (target === t('system.title.custom_db')) {
      textEn = 'Custom Database';
    }
    const smallLetterFirstLetter = textEn.split(/[ ]+/)[0].toLowerCase();

    if (smallLetterFirstLetter === selectedDB) {
      return;
    }

    this.setState({
      selectedDB: smallLetterFirstLetter,
      otherHostError: false,
      customHostError: false,
      portError: false,
      databaseError: false,
      userNameError: false,
      passwordError: false,
      isOtherHostFocus: false,
      isCustomHostFocus: false,
    }, () => {
      if (smallLetterFirstLetter !== 'default') {
        this.getUserDBDetailSettings(smallLetterFirstLetter);
      } else {
        this.setState({
          errorMsg: '',
          isGlobalErrorLoading: false,
        });
      }
    });
  }

  handleOssCustomHostChange(event) {
    this.setState({
      customOssHostError: false,
      customOssHost: event.target.value,
    });
  }

  handleOssOtherHostChange(event) {
    this.setState({
      otherOssHostError: false,
      otherOssHost: event.target.value,
    });
  }

  handleOssPortChange(event) {
    this.setState({
      ossPortError: false,
      ossPort: event.target.value,
    });
  }

  handleOssDBChange(event) {
    this.setState({
      ossDatabaseError: false,
      ossDatabase: event.target.value,
    });
  }

  handleOssUserNameChange(event) {
    this.setState({
      ossUserNameError: false,
      ossUserName: event.target.value,
    });
  }

  handleOssPWChange(event) {
    this.setState({
      ossPasswordError: false,
      ossPassword: event.target.value,
    });
  }

  handleOssUserNameFocus() {
    this.setState({
      isAutoCompleteOssName: true,
    });
  }

  handleOssPWFocus() {
    this.setState({
      isAutoCompleteOssPass: true,
    });
  }

  handleCustomHostFocus() {
    this.setState({
      isCustomHostFocus: true,
    });
  }

  handleOtherHostFocus() {
    this.setState({
      isOtherHostFocus: true,
    });
  }

  handleOssCustomHostFocus() {
    this.setState({
      isCustomOssHostFocus: true,
    });
  }

  handleOssOtherHostFocus() {
    this.setState({
      isOtherOssHostFocus: true,
    });
  }

  handleCampSchemeChange(event) {
    this.setState({
      campScheme: event.target.value,
    });
  }

  handleJobCountChange(event) {
    this.setState({
      jobCountError: false,
      jobCount: event.target.value,
    });
  }

  handleCampCustomHostFocus() {
    this.setState({
      isCustomCampHostFocus: true,
    });
  }

  handleCampCustomHostChange(event) {
    this.setState({
      customCampHostError: false,
      customCampHost: event.target.value,
    });
  }

  handleCampPortChange(event) {
    this.setState({
      campPortError: false,
      campPort: event.target.value,
    });
  }

  handleOssTabChange(e) {
    const target = e.target.text;
    const { selectedOssDB } = this.state;
    const { t } = this.props;
    let textEn;

    if (target === t('system.title.default')) {
      textEn = 'Default';
    }
    if (target === t('system.title.other_clarity_system')) {
      textEn = 'Other Clarity System';
    }
    if (target === t('system.title.custom_db')) {
      textEn = 'Custom Database';
    }

    if (target === t('system.title.hybrid')) {
      textEn = 'Hybrid';
    }

    const smallLetterFirstLetter = textEn.split(/[ ]+/)[0].toLowerCase();

    if (smallLetterFirstLetter === selectedOssDB) {
      return;
    }

    this.setState({
      selectedOssDB: smallLetterFirstLetter,
      otherOssHostError: false,
      customOssHostError: false,
      ossPortError: false,
      ossDatabaseError: false,
      ossUserNameError: false,
      ossPasswordError: false,
      isOtherOssHostFocus: false,
      isCustomOssHostFocus: false,
    }, () => {
      if (smallLetterFirstLetter !== 'default' && smallLetterFirstLetter !== 'hybrid') {
        this.getOssDBDetailSettings(smallLetterFirstLetter);
      } else {
        this.setState({
          ossErrorMsg: '',
          isOssGlobalErrorLoading: false,
        });
      }
    });
  }

  handleCampTabChange(e) {
    const target = e.target.text;
    const { selectedCampDB } = this.state;
    const { t } = this.props;
    let textEn;

    if (target === t('system.title.default')) {
      textEn = 'Default';
    }
    if (target === t('system.title.custom_camp')) {
      textEn = 'Custom Camp';
    }

    const smallLetterFirstLetter = textEn.split(/[ ]+/)[0].toLowerCase();

    if (smallLetterFirstLetter === selectedCampDB) {
      return;
    }

    this.setState({
      selectedCampDB: smallLetterFirstLetter,
      customCampHostError: false,
      campPortError: false,
      isCustomOssHostFocus: false,
    }, () => {
      if (smallLetterFirstLetter !== 'default') {
        this.getCampDetailSettings(smallLetterFirstLetter);
      } else {
        this.setState({
          campErrorMsg: '',
          isCampGlobalErrorLoading: false,
        });
      }
    });
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  onUpdateFetchData() {
    api
      .useUpdatersMenu()
      .then((res) => {
        const systemObj = { ...res.response.system };
        if (systemObj && systemObj.ui_db) {
          this.getUserDBSettings();
        }
        if (systemObj && systemObj.oss_db) {
          this.getOssDBSettings();
        }
        if (systemObj && systemObj.camp) {
          this.getCampSettings();
        }
        if (systemObj && systemObj.job_count) {
          this.getJobCountSettings();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onSubmit() {
    const { t } = this.props;
    if (!this.validation()) {
      return;
    }

    this.modalAction = t('modal.title.attention');
    this.modalBody = t('system.message.save_web_db');

    this.setState({
      isOpenModal: true,
      isModalLoading: false,
      isModalErrorLoading: false,
    });
  }

  onSubmitWithOss() {
    const { t } = this.props;
    if (!this.ossValidation()) {
      return;
    }

    this.modalAction = t('modal.title.attention');
    this.modalBody = t('system.message.save_oss_db');

    this.setState({
      isOpenOssModal: true,
      isOssModalLoading: false,
      isOssModalErrorLoading: false,
    });
  }

  onSubmitWithCamp() {
    const { t } = this.props;
    if (!this.campValidation()) {
      return;
    }

    this.modalAction = t('modal.title.attention');
    this.modalBody = t('system.message.save_camp');

    this.setState({
      isOpenCampModal: true,
      isCampModalLoading: false,
      isCampModalErrorLoading: false,
    });
  }

  onSubmitWithJobCount() {
    const { t } = this.props;
    this.modalAction = t('modal.title.attention');
    this.modalBody = t('system.message.save_job_count');

    this.setState({
      isOpenJobModal: true,
      isJobModalLoading: false,
      isJobModalErrorLoading: false,
    });
  }

  setUserDBSettings() {
    const {
      selectedDB, otherHost, customHost, port, database, userName, password
    } = this.state;
    const { t, navigate } = this.props;
    let obj;

    if (selectedDB === 'default') {
      obj = {
        selected_db: 'default',
      };
    } else if (selectedDB === 'other') {
      obj = {
        selected_db: 'other',
        clarity_ip: otherHost,
      };
    } else if (selectedDB === 'custom') {
      obj = {
        selected_db: 'custom',
        db_info: {
          host: customHost,
          port,
          database,
          username: userName,
          password,
        },
      };
    }

    this.setState({
      isModalLoading: true,
    }, () => {
      api
        .setUserDBSettings(obj)
        .then(() => {
          //console.log(res);
          this.modalAction = t('modal.title.notice');
          this.modalBody = t('system.message.success_update_web_db');
          this.modalSubBody = t('system.message.success_update_web_db_restart');
          this.setState({
            isModalLoading: false,
            isModalErrorLoading: true,
          });
        })
        .catch((err) => {
          //console.log(err);
          if (!err.data) {
            this.modalAction = t('modal.title.attention');
            this.modalBody = t('system.message.error_connection_refused');
            this.modalSubBody = '';
            return this.setState({
              isModalLoading: false,
              isModalErrorLoading: true,
            });
          }
          const o = err.data.response;

          this.modalAction = t('modal.title.attention');

          if (!o.error) {
            this.modalBody = t('modal.error.unknow_error');
            this.modalSubBody = '';
          }

          if (o.error === '422-362') {
            if (this.props.state.user.main_page === 'dashboard') {
              navigate('/main', { replace: true });
            } else if (this.props.state.user.main_page === 'results') {
              navigate('/results', { replace: true });
            } else {
              navigate(`/results/${this.props.state.user.main_page}`, { replace: true });
            }
          }

          if (o.error_description) {
            this.modalBody = o.error_description;
            this.modalSubBody = '';
          } else {
            this.modalBody = t('modal.error.unknow_error');
            this.modalSubBody = '';
          }

          this.setState({
            isModalLoading: false,
            isModalErrorLoading: true,
          });
        });
    });
  }

  setOssDBSettings() {
    const {
      selectedOssDB, otherOssHost, customOssHost, ossPort, ossDatabase, ossUserName, ossPassword
    } = this.state;
    const { t, navigate } = this.props;
    let obj;

    if (selectedOssDB === 'default') {
      obj = {
        selected_db: 'default',
      };
    } else if (selectedOssDB === 'other') {
      obj = {
        selected_db: 'other',
        clarity_ip: otherOssHost,
      };
    } else if (selectedOssDB === 'custom') {
      obj = {
        selected_db: 'custom',
        db_info: {
          host: customOssHost,
          port: ossPort,
          database: ossDatabase,
          username: ossUserName,
          password: ossPassword,
        },
      };
    } else if (selectedOssDB === 'hybrid') {
      obj = {
        selected_db: 'hybrid',
      };
    }

    this.setState({
      isOssModalLoading: true,
    }, () => {
      api
        .setOssDBSettings(obj)
        .then(() => {
          //console.log(res);
          this.modalAction = t('modal.title.notice');
          this.modalBody = t('system.message.success_update_oss_db');
          this.modalSubBody = t('system.message.success_update_web_db_restart');
          this.setState({
            isOssModalLoading: false,
            isOssModalErrorLoading: true,
          });
        })
        .catch((err) => {
          //console.log(err);
          if (!err.data) {
            this.modalAction = t('modal.title.attention');
            this.modalBody = t('system.message.error_connection_refused');
            this.modalSubBody = '';
            return this.setState({
              isOssModalLoading: false,
              isOssModalErrorLoading: true,
            });
          }
          const o = err.data.response;

          this.modalAction = t('modal.title.attention');

          if (!o.error) {
            this.modalBody = t('modal.error.unknow_error');
            this.modalSubBody = '';
          }

          if (o.error === '422-362') {
            if (this.props.state.user.main_page === 'dashboard') {
              navigate('/main', { replace: true });
            } else if (this.props.state.user.main_page === 'results') {
              navigate('/results', { replace: true });
            } else {
              navigate(`/results/${this.props.state.user.main_page}`, { replace: true });
            }
          }

          if (o.error_description) {
            this.modalBody = o.error_description;
            this.modalSubBody = '';
          } else {
            this.modalBody = t('modal.error.unknow_error');
            this.modalSubBody = '';
          }

          this.setState({
            isOssModalLoading: false,
            isOssModalErrorLoading: true,
          });
        });
    });
  }

  setCampSettings() {
    const {
      selectedCampDB, customCampHost, campScheme, campPort
    } = this.state;
    const { t, navigate } = this.props;
    let obj;

    if (selectedCampDB === 'default') {
      obj = {
        selected_config: 'default',
      };
    } else if (selectedCampDB === 'custom') {
      obj = {
        selected_config: 'custom',
        camp_info: {
          host: customCampHost,
          scheme: campScheme,
          port: campPort,
        },
      };
    }

    this.setState({
      isCampModalLoading: true,
    }, () => {
      api
        .setCampSettings(obj)
        .then(() => {
          //console.log(res);
          this.modalAction = t('modal.title.notice');
          this.modalBody = t('system.message.success_update_camp');
          this.modalSubBody = t('system.message.success_update_camp_restart');
          this.setState({
            isCampModalLoading: false,
            isCampModalErrorLoading: true,
          });
        })
        .catch((err) => {
          //console.log(err);
          if (!err.data) {
            this.modalAction = t('modal.title.attention');
            this.modalBody = t('system.message.error_connection_refused');
            this.modalSubBody = '';
            return this.setState({
              isCampModalLoading: false,
              isCampModalErrorLoading: true,
            });
          }
          const o = err.data.response;

          this.modalAction = t('modal.title.attention');

          if (!o.error) {
            this.modalBody = t('modal.error.unknow_error');
            this.modalSubBody = '';
          }

          if (o.error === '422-362') {
            if (this.props.state.user.main_page === 'dashboard') {
              navigate('/main', { replace: true });
            } else if (this.props.state.user.main_page === 'results') {
              navigate('/results', { replace: true });
            } else {
              navigate(`/results/${this.props.state.user.main_page}`, { replace: true });
            }
          }

          if (o.error_description) {
            this.modalBody = o.error_description;
            this.modalSubBody = '';
          } else {
            this.modalBody = t('modal.error.unknow_error');
            this.modalSubBody = '';
          }

          this.setState({
            isCampModalLoading: false,
            isCampModalErrorLoading: true,
          });
        });
    });
  }

  setJobCountSettings() {
    const { jobCount } = this.state;
    const { t, navigate } = this.props;

    const obj = {
      job_count: jobCount,
    };

    this.setState({
      isJobModalLoading: true,
    }, () => {
      api
        .setJobCountSettings(obj)
        .then(() => {
          //console.log(res);
          this.modalAction = t('modal.title.notice');
          this.modalBody = t('system.message.success_update_job_count');
          this.modalSubBody = t('system.message.success_update_camp_restart');
          this.setState({
            isJobModalLoading: false,
            isJobModalErrorLoading: true,
          });
        })
        .catch((err) => {
          //console.log(err);
          if (!err.data) {
            this.modalAction = t('modal.title.attention');
            this.modalBody = t('system.message.error_connection_refused');
            this.modalSubBody = '';
            return this.setState({
              isJobModalLoading: false,
              isJobModalErrorLoading: true,
            });
          }
          const o = err.data.response;

          this.modalAction = t('modal.title.attention');

          if (!o.error) {
            this.modalBody = t('modal.error.unknow_error');
            this.modalSubBody = '';
          }

          if (o.error === '422-362') {
            if (this.props.state.user.main_page === 'dashboard') {
              navigate('/main', { replace: true });
            } else if (this.props.state.user.main_page === 'results') {
              navigate('/results', { replace: true });
            } else {
              navigate(`/results/${this.props.state.user.main_page}`, { replace: true });
            }
          }

          if (o.error_description) {
            this.modalBody = o.error_description;
            this.modalSubBody = '';
          } else {
            this.modalBody = t('modal.error.unknow_error');
            this.modalSubBody = '';
          }

          this.setState({
            isJobModalLoading: false,
            isJobModalErrorLoading: true,
          });
        });
    });
  }

  getUserDBSettings() {
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getUserDBSettings()
        .then((res) => {
          //console.log(res);
          const data = res.response;
          this.setState({
            isLoading: false,
            selectedDB: data,
            isGlobalErrorLoading: false,
            errorMsg: '',
          }, () => {
            if (data !== 'default') {
              this.getUserDBDetailSettings(data);
            }
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          const text = o.error_description || null;

          this.setState({
            isLoading: false,
            isGlobalErrorLoading: true,
            errorMsg: text,
          });
        });
    });
  }

  getUserDBDetailSettings(value) {
    const obj = {
      selected_db: value,
    };

    this.setState({
      isOtherLoading: true,
    }, () => {
      api
        .getUserDBDetailSettings(obj)
        .then((res) => {
          //console.log(res);
          const data = res.response;
          if (value === 'other') {
            this.setState({
              isOtherLoading: false,
              isGlobalErrorLoading: false,
              otherHost: data || '',
              errorMsg: '',
            });
          } else {
            this.setState({
              isOtherLoading: false,
              isGlobalErrorLoading: false,
              errorMsg: '',
              customHost: data.host || '',
              port: data.port || '',
              database: data.database || '',
              userName: data.username || '',
            });
          }
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          const text = o.error_description || null;

          this.setState({
            isOtherLoading: false,
            isGlobalErrorLoading: true,
            errorMsg: text,
          });
        });
    });
  }

  getOssDBSettings() {
    this.setState({
      isOssLoading: true,
    }, () => {
      api
        .getOssDBSettings()
        .then((res) => {
          //console.log(res);
          const data = res.response;
          this.setState({
            isOssLoading: false,
            selectedOssDB: data,
            isOssGlobalErrorLoading: false,
            ossErrorMsg: '',
          }, () => {
            if (data !== 'default' && data !== 'hybrid') {
              this.getOssDBDetailSettings(data);
            }
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          const text = o.error_description || null;

          this.setState({
            isOssLoading: false,
            isOssGlobalErrorLoading: true,
            ossErrorMsg: text,
          });
        });
    });
  }

  getOssDBDetailSettings(value) {
    const obj = {
      selected_db: value,
    };

    this.setState({
      isOssDetailLoading: true,
    }, () => {
      api
        .getOssDBDetailSettings(obj)
        .then((res) => {
          //console.log(res);
          const data = res.response;
          if (value === 'other') {
            this.setState({
              isOssDetailLoading: false,
              isOssGlobalErrorLoading: false,
              otherOssHost: data || '',
              ossErrorMsg: '',
            });
          } else {
            this.setState({
              isOssDetailLoading: false,
              isOssGlobalErrorLoading: false,
              ossErrorMsg: '',
              customOssHost: data.host || '',
              ossPort: data.port || '',
              ossDatabase: data.database || '',
              ossUserName: data.username || '',
            });
          }
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          const text = o.error_description || null;

          this.setState({
            isOssDetailLoading: false,
            isOssGlobalErrorLoading: true,
            ossErrorMsg: text,
          });
        });
    });
  }

  getCampSettings() {
    this.setState({
      isCampLoading: true,
    }, () => {
      api
        .getCampSettings()
        .then((res) => {
          const data = res.response;
          this.setState({
            isCampLoading: false,
            selectedCampDB: data,
            isCampGlobalErrorLoading: false,
            campErrorMsg: '',
          }, () => {
            if (data !== 'default') {
              this.getCampDetailSettings(data);
            }
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          const text = o.error_description || null;

          this.setState({
            isCampLoading: false,
            isCampGlobalErrorLoading: true,
            campErrorMsg: text,
          });
        });
    });
  }

  getCampDetailSettings(value) {
    const obj = {
      selected_config: value,
    };

    this.setState({
      isCampDetailLoading: true,
    }, () => {
      api
        .getCampDetailSettings(obj)
        .then((res) => {
          //console.log(res);
          const data = res.response;
          this.setState({
            isCampDetailLoading: false,
            isCampGlobalErrorLoading: false,
            campErrorMsg: '',
            campScheme: data.scheme || 'http',
            customCampHost: data.host || '',
            campPort: data.port || '',
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          const text = o.error_description || null;

          this.setState({
            isCampDetailLoading: false,
            isCampGlobalErrorLoading: true,
            campErrorMsg: text,
          });
        });
    });
  }

  getJobCountSettings() {
    this.setState({
      isjobCountLoading: true,
    }, () => {
      api
        .getJobCountSettings()
        .then((res) => {
          const data = res.response;
          this.setState({
            isjobCountLoading: false,
            jobCount: data,
            isJobCountGlobalErrorLoading: false,
            jobCountErrorMsg: '',
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          const text = o.error_description || null;

          this.setState({
            isjobCountLoading: false,
            isJobCountGlobalErrorLoading: true,
            jobCountErrorMsg: text,
          });
        });
    });
  }

  requiredAdmin() {
    const { state, navigate } = this.props;
    if (!state.user.isAdmin) {
      if (localStorage.getItem('main_page') === 'dashboard') {
        navigate('/main', { replace: true });
      } else if (localStorage.getItem('main_page') === 'results') {
        navigate('/results', { replace: true });
      } else {
        navigate(`/results/${this.props.state.user.main_page}`, { replace: true });
      }
    }
  }

  validation() {
    const {
      selectedDB, otherHost, customHost, port, database, userName, password
    } = this.state;
    const { t } = this.props;

    if (selectedDB === 'other') {
      if (otherHost === '') {
        this.modalAction = t('modal.title.attention');
        this.modalBody = t('modal.error.host_is_required');
        this.setState({
          otherHostError: true,
          isOpenAlertModal: true,
        });
        return false;
      }
    }

    if (selectedDB === 'custom') {
      if (customHost === '') {
        this.modalAction = t('modal.title.attention');
        this.modalBody = t('modal.error.host_is_required');
        this.setState({
          otherHostError: true,
          isOpenAlertModal: true,
        });
        return false;
      }
      if (port === '') {
        this.modalAction = t('modal.title.attention');
        this.modalBody = t('modal.error.port_required');
        this.setState({
          portError: true,
          isOpenAlertModal: true,
        });
        return false;
      }
      if (database === '') {
        this.modalAction = t('modal.title.attention');
        this.modalBody = t('system.message.required_database');
        this.setState({
          databaseError: true,
          isOpenAlertModal: true,
        });
        return false;
      }
      if (userName === '') {
        this.modalAction = t('modal.title.attention');
        this.modalBody = t('modal.error.user_name_required');
        this.setState({
          userNameError: true,
          isOpenAlertModal: true,
        });
        return false;
      }
      if (password === '') {
        this.modalAction = t('modal.title.attention');
        this.modalBody = t('modal.error.password_required');
        this.setState({
          passwordError: true,
          isOpenAlertModal: true,
        });
        return false;
      }
    }

    return true;
  }

  ossValidation() {
    const {
      selectedOssDB, otherOssHost, customOssHost, ossPort, ossDatabase, ossUserName, ossPassword
    } = this.state;
    const { t } = this.props;

    if (selectedOssDB === 'other') {
      if (otherOssHost === '') {
        this.modalAction = t('modal.title.attention');
        this.modalBody = t('modal.error.host_is_required');
        this.setState({
          otherOssHostError: true,
          isOpenAlertModal: true,
        });
        return false;
      }
    }

    if (selectedOssDB === 'custom') {
      if (customOssHost === '') {
        this.modalAction = t('modal.title.attention');
        this.modalBody = t('modal.error.host_is_required');
        this.setState({
          customOssHostError: true,
          isOpenAlertModal: true,
        });
        return false;
      }
      if (ossPort === '') {
        this.modalAction = t('modal.title.attention');
        this.modalBody = t('modal.error.port_required');
        this.setState({
          ossPortError: true,
          isOpenAlertModal: true,
        });
        return false;
      }
      if (ossDatabase === '') {
        this.modalAction = t('modal.title.attention');
        this.modalBody = t('system.message.required_database');
        this.setState({
          ossDatabaseError: true,
          isOpenAlertModal: true,
        });
        return false;
      }
      if (ossUserName === '') {
        this.modalAction = t('modal.title.attention');
        this.modalBody = t('modal.error.user_name_required');
        this.setState({
          ossUserNameError: true,
          isOpenAlertModal: true,
        });
        return false;
      }
      if (ossPassword === '') {
        this.modalAction = t('modal.title.attention');
        this.modalBody = t('modal.error.password_required');
        this.setState({
          ossPasswordError: true,
          isOpenAlertModal: true,
        });
        return false;
      }
    }

    return true;
  }

  campValidation() {
    const { selectedCampDB, customCampHost, campPort } = this.state;
    const { t } = this.props;

    if (selectedCampDB === 'custom') {
      if (customCampHost === '') {
        this.modalAction = t('modal.title.attention');
        this.modalBody = t('modal.error.host_is_required');
        this.setState({
          customCampHostError: true,
          isOpenAlertModal: true,
        });
        return false;
      }
      if (campPort === '') {
        this.modalAction = t('modal.title.attention');
        this.modalBody = t('modal.error.port_required');
        this.setState({
          campPortError: true,
          isOpenAlertModal: true,
        });
        return false;
      }
    }
    return true;
  }

  closeModal() {
    this.setState({
      isOpenModal: false,
      isOpenOssModal: false,
      isOpenAlertModal: false,
      isOpenCampModal: false,
      isOpenJobModal: false,
      isModalErrorLoading: false,
      isOssModalErrorLoading: false,
      isCampModalErrorLoading: false,
      isJobModalErrorLoading: false,
      isOtherHostFocus: false,
      isCustomHostFocus: false,
      isOtherOssHostFocus: false,
      isCustomOssHostFocus: false,
      isCustomCampHostFocus: false,
    });
  }

  render() {
    const {
      isLoading,
      isOtherLoading,
      isGlobalErrorLoading,
      isOssLoading,
      isOssDetailLoading,
      isOssGlobalErrorLoading,
      errorMsg,
      ossErrorMsg,
      selectedDB,
      otherHost,
      customHost,
      port,
      database,
      userName,
      password,
      otherHostError,
      customHostError,
      portError,
      databaseError,
      userNameError,
      passwordError,
      selectedOssDB,
      otherOssHost,
      customOssHost,
      ossPort,
      ossDatabase,
      ossUserName,
      ossPassword,
      otherOssHostError,
      customOssHostError,
      ossPortError,
      ossDatabaseError,
      ossUserNameError,
      ossPasswordError,
      isModalLoading,
      isModalErrorLoading,
      isOssModalErrorLoading,
      isOssModalLoading,
      isAutoCompleteName,
      isAutoCompletePass,
      isAutoCompleteOssName,
      isAutoCompleteOssPass,
      isOtherHostFocus,
      isCustomHostFocus,
      isOtherOssHostFocus,
      isCustomOssHostFocus,
      isCampLoading,
      isCampDetailLoading,
      selectedCampDB,
      isCampGlobalErrorLoading,
      campErrorMsg,
      campScheme,
      customCampHost,
      isCustomCampHostFocus,
      customCampHostError,
      campPort,
      campPortError,
      isjobCountLoading,
      isJobCountGlobalErrorLoading,
      jobCountErrorMsg,
      jobCount,
      jobCountError,
      isJobModalErrorLoading,
      isCampModalErrorLoading,
      isJobModalLoading,
      isCampModalLoading,
    } = this.state;

    const { t } = this.props;

    const {
      systemObj,
    } = this.props.state.company;

    const renderIfReady = (element) => {
      return !isLoading ? (
        element
      ) : (
        <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
          {t('modal.message.loading')}
        </Loader>
      );
    };

    const renderIfReadyDetailElement = (element) => {
      return !isOtherLoading ? (
        element
      ) : (
        <Loader size="medium" inline="centered" style={{ display: 'block' }}>
          {t('modal.message.loading')}
        </Loader>
      );
    };

    const renderOssIfReady = (element) => {
      return !isOssLoading ? (
        element
      ) : (
        <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
          {t('modal.message.loading')}
        </Loader>
      );
    };

    const renderOssIfReadyDetailElement = (element) => {
      return !isOssDetailLoading ? (
        element
      ) : (
        <Loader size="medium" inline="centered" style={{ display: 'block' }}>
          {t('modal.message.loading')}
        </Loader>
      );
    };

    const renderCampIfReady = (element) => {
      return !isCampLoading ? (
        element
      ) : (
        <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
          {t('modal.message.loading')}
        </Loader>
      );
    };

    const renderCampIfReadyDetailElement = (element) => {
      return !isCampDetailLoading ? (
        element
      ) : (
        <Loader size="medium" inline="centered" style={{ display: 'block' }}>
          {t('modal.message.loading')}
        </Loader>
      );
    };

    const renderJobCountIfReady = (element) => {
      return !isjobCountLoading ? (
        element
      ) : (
        <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
          {t('modal.message.loading')}
        </Loader>
      );
    };

    return (
      <div>
        <div className="content">
          {
            systemObj && systemObj.ui_db && (
              <div className="setting_small_box setting_small_box_2">
                <h2 className="page_title">
                  {t('system.title.web_db_settings')}
                  {isGlobalErrorLoading ? <span className="error">{errorMsg}</span> : null}
                </h2>
                {renderIfReady(
                  <div>
                    <div className="setting_contnets" style={{ marginBottom: '35px' }}>
                      <div className="setting_contnet_wrap">
                        <div className="custom_content">
                          <h3 className="setting_content_title">{t('system.title.connect_db')}</h3>
                          <div className="setting_content">
                            <div className="small_box_3" style={{ width: '440px' }}>
                              <div className="switch">
                                <a
                                  className={cx({ checked: selectedDB === 'default' })}
                                  onClick={this.handleTabChange}
                                >
                                  {t('system.title.default')}
                                </a>
                                <a
                                  className={cx({ checked: selectedDB === 'other' })}
                                  onClick={this.handleTabChange}
                                >
                                  {t('system.title.other_clarity_system')}
                                </a>
                                <a
                                  className={cx({ checked: selectedDB === 'custom' })}
                                  onClick={this.handleTabChange}
                                >
                                  {t('system.title.custom_db')}
                                </a>
                              </div>
                            </div>
                          </div>
                          {
                            selectedDB === 'default'
                            && (
                              <div className="" style={{ width: '100%', display: 'inline-block' }}>
                                <p className="text">{t('system.title.db_clarity_system')}</p>
                              </div>
                            )
                          }
                          {
                            selectedDB === 'other'
                            && (
                              <div className="" style={{ width: '100%', display: 'inline-block' }}>
                                <p className="text">{t('system.title.db_external_clarity_system')}</p>
                              </div>
                            )
                          }
                          {
                            selectedDB === 'custom'
                            && (
                              <div className="" style={{ width: '100%', display: 'inline-block' }}>
                                <p className="text">{t('system.title.user_defined_db')}</p>
                              </div>
                            )
                          }
                        </div>
                      </div>
                      <div className="setting_contnet_wrap">
                        <div className="custom_content">
                          {renderIfReadyDetailElement(
                            <div>
                              {
                                selectedDB === 'other'
                                && (
                                  <div>
                                    <div className="setting_contnet_wrap">
                                      <div className="left_content">
                                        <h3 className="setting_content_title">{t('system.list.host')}</h3>
                                        <div className="setting_content">
                                          <input
                                            type="text"
                                            style={{ width: '50%' }}
                                            value={otherHost}
                                            onFocus={this.handleOtherHostFocus}
                                            onChange={this.handleOtherHostChange}
                                            placeholder={`${t('system.list.example')} 127.0.0.1`}
                                          />
                                          {
                                            isOtherHostFocus && !otherHostError ? (
                                              <div className={cx('error', { show: !otherHostError })} style={{ color: '#7434fe' }}>
                                                {t('system.message.host_local_network')}
                                              </div>
                                            ) : (
                                              <div className={cx('error', { show: otherHostError })}>
                                                {t('modal.error.host_is_required')}
                                              </div>
                                            )
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              }
                              {
                                selectedDB === 'custom'
                                && (
                                  <div>
                                    <div className="setting_contnet_wrap">
                                      <div className="left_content">
                                        <h3 className="setting_content_title">{t('system.list.host')}</h3>
                                        <div className="setting_content">
                                          <input
                                            type="text"
                                            style={{ width: '50%' }}
                                            value={customHost}
                                            onFocus={this.handleCustomHostFocus}
                                            onChange={this.handleCustomHostChange}
                                            placeholder={`${t('system.list.example')} 127.0.0.1`}
                                          />
                                          {
                                            isCustomHostFocus && !customHostError ? (
                                              <div className={cx('error', { show: !customHostError })} style={{ color: '#7434fe' }}>
                                                {t('system.message.host_local_network')}
                                              </div>
                                            ) : (
                                              <div className={cx('error', { show: customHostError })}>
                                                {t('modal.error.host_is_required')}
                                              </div>
                                            )
                                          }
                                        </div>
                                      </div>
                                      <div className="right_content">
                                        <h3 className="setting_content_title">{t('system.list.port')}</h3>
                                        <div className="setting_content">
                                          <input
                                            type="text"
                                            style={{ width: '50%' }}
                                            value={port}
                                            onChange={this.handlePortChange}
                                            placeholder={`${t('system.list.example')} 5432`}
                                          />
                                          <div className={cx('error', { show: portError })}>
                                            {t('modal.error.port_required')}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="setting_contnet_wrap">
                                      <div className="left_content">
                                        <h3 className="setting_content_title">{t('system.title.database')}</h3>
                                        <div className="setting_content">
                                          <input
                                            type="text"
                                            style={{ width: '50%' }}
                                            value={database}
                                            onChange={this.handleDBChange}
                                            placeholder={t('system.title.database_placeholder')}
                                          />
                                          <div className={cx('error', { show: databaseError })}>
                                            {t('system.message.required_database')}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="right_content">
                                        <h3 className="setting_content_title">{t('modal.title.user_name')}</h3>
                                        <div className="setting_content">
                                          <input
                                            type="text"
                                            style={{ width: '50%' }}
                                            value={userName}
                                            onChange={this.handleUserNameChange}
                                            onFocus={this.handleUserNameFocus}
                                            placeholder="Your Name"
                                            readOnly={!isAutoCompleteName}
                                          />
                                          <div className={cx('error', { show: userNameError })}>
                                            {t('modal.error.user_name_required')}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="setting_contnet_wrap">
                                      <div className="left_content">
                                        <h3 className="setting_content_title">{t('modal.title.password')}</h3>
                                        <div className="setting_content">
                                          <input
                                            type="password"
                                            name="pass"
                                            style={{ width: '50%' }}
                                            value={password}
                                            onChange={this.handlePWChange}
                                            onFocus={this.handlePWFocus}
                                            placeholder={t('modal.title.password')}
                                            readOnly={!isAutoCompletePass}
                                          />
                                          <div className={cx('error', { show: passwordError })}>
                                            {t('modal.error.password_required')}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="setting_contnet_wrap" style={{ marginTop: '0' }}>
                        <div className="setting_content">
                          <div className="right_box">
                            <a
                              className="update"
                              onClick={this.onSubmit}
                            >
                              {t('modal.button.save')}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )
          }
          {
            systemObj && systemObj.ui_db && (systemObj.oss_db || systemObj.camp || systemObj.job_count) ? (
              <div className="line" />
            ) : null
          }
          {
            systemObj && systemObj.oss_db && (
              <div className="setting_small_box setting_small_box_2">
                <h2 className="page_title">
                  {t('system.title.oss_db_settings')}
                  {isOssGlobalErrorLoading ? <span className="error">{ossErrorMsg}</span> : null}
                </h2>
                {renderOssIfReady(
                  <div>
                    <div className="setting_contnets" style={{ marginBottom: '35px' }}>
                      <div className="setting_contnet_wrap">
                        <div className="custom_content">
                          <h3 className="setting_content_title">{t('system.title.connect_db')}</h3>
                          <div className="setting_content">
                            <div className="small_box_4" style={{ width: '590px' }}>
                              <div className="switch">
                                <a
                                  className={cx({ checked: selectedOssDB === 'default' })}
                                  onClick={this.handleOssTabChange}
                                >
                                  {t('system.title.default')}
                                </a>
                                <a
                                  className={cx({ checked: selectedOssDB === 'other' })}
                                  onClick={this.handleOssTabChange}
                                >
                                  {t('system.title.other_clarity_system')}
                                </a>
                                <a
                                  className={cx({ checked: selectedOssDB === 'custom' })}
                                  onClick={this.handleOssTabChange}
                                >
                                  {t('system.title.custom_db')}
                                </a>
                                <a
                                  className={cx({ checked: selectedOssDB === 'hybrid' })}
                                  onClick={this.handleOssTabChange}
                                >
                                  {t('system.title.hybrid')}
                                </a>
                              </div>
                            </div>
                          </div>
                          {
                            selectedOssDB === 'default'
                            && (
                              <div className="" style={{ width: '100%', display: 'inline-block' }}>
                                <p className="text">{t('system.title.oss_clarity_system')}</p>
                              </div>
                            )
                          }
                          {
                            selectedOssDB === 'other'
                            && (
                              <div className="" style={{ width: '100%', display: 'inline-block' }}>
                                <p className="text">{t('system.title.oss_external_clarity_system')}</p>
                              </div>
                            )
                          }
                          {
                            selectedOssDB === 'custom'
                            && (
                              <div className="" style={{ width: '100%', display: 'inline-block' }}>
                                <p className="text">{t('system.title.user_defined_oss')}</p>
                              </div>
                            )
                          }
                          {
                            selectedOssDB === 'hybrid'
                            && (
                              <div className="" style={{ width: '100%', display: 'inline-block' }}>
                                <p className="text">{t('system.title.hybrid_oss')}</p>
                              </div>
                            )
                          }
                        </div>
                      </div>
                      <div className="setting_contnet_wrap">
                        <div className="custom_content">
                          {renderOssIfReadyDetailElement(
                            <div>
                              {
                                selectedOssDB === 'other'
                                && (
                                  <div>
                                    <div className="setting_contnet_wrap">
                                      <div className="left_content">
                                        <h3 className="setting_content_title">{t('modal.title.host')}</h3>
                                        <div className="setting_content">
                                          <input
                                            type="text"
                                            style={{ width: '50%' }}
                                            value={otherOssHost}
                                            onFocus={this.handleOssOtherHostFocus}
                                            onChange={this.handleOssOtherHostChange}
                                            placeholder={`${t('system.list.example')} 127.0.0.1`}
                                          />
                                          {
                                            isOtherOssHostFocus && !otherOssHostError ? (
                                              <div className={cx('error', { show: !otherOssHostError })} style={{ color: '#7434fe' }}>
                                                {t('system.message.host_local_network')}
                                              </div>
                                            ) : (
                                              <div className={cx('error', { show: otherOssHostError })}>
                                                {t('modal.error.host_is_required')}
                                              </div>
                                            )
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              }
                              {
                                selectedOssDB === 'custom'
                                && (
                                  <div>
                                    <div className="setting_contnet_wrap">
                                      <div className="left_content">
                                        <h3 className="setting_content_title">{t('modal.title.host')}</h3>
                                        <div className="setting_content">
                                          <input
                                            type="text"
                                            style={{ width: '50%' }}
                                            value={customOssHost}
                                            onFocus={this.handleOssCustomHostFocus}
                                            onChange={this.handleOssCustomHostChange}
                                            placeholder={`${t('system.list.example')} 127.0.0.1`}
                                          />
                                          {
                                            isCustomOssHostFocus && !customOssHostError ? (
                                              <div className={cx('error', { show: !customOssHostError })} style={{ color: '#7434fe' }}>
                                                {t('system.message.host_local_network')}
                                              </div>
                                            ) : (
                                              <div className={cx('error', { show: customOssHostError })}>
                                                {t('modal.error.host_is_required')}
                                              </div>
                                            )
                                          }
                                        </div>
                                      </div>
                                      <div className="right_content">
                                        <h3 className="setting_content_title">{t('modal.title.port')}</h3>
                                        <div className="setting_content">
                                          <input
                                            type="text"
                                            style={{ width: '50%' }}
                                            value={ossPort}
                                            onChange={this.handleOssPortChange}
                                            placeholder={`${t('system.list.example')} 5432`}
                                          />
                                          <div className={cx('error', { show: ossPortError })}>
                                            {t('modal.error.port_required')}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="setting_contnet_wrap">
                                      <div className="left_content">
                                        <h3 className="setting_content_title">{t('system.title.database')}</h3>
                                        <div className="setting_content">
                                          <input
                                            type="text"
                                            style={{ width: '50%' }}
                                            value={ossDatabase}
                                            onChange={this.handleOssDBChange}
                                            placeholder={t('system.title.database_placeholder')}
                                          />
                                          <div className={cx('error', { show: ossDatabaseError })}>
                                            {t('system.message.required_database')}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="right_content">
                                        <h3 className="setting_content_title">{t('modal.title.user_name')}</h3>
                                        <div className="setting_content">
                                          <input
                                            type="text"
                                            style={{ width: '50%' }}
                                            value={ossUserName}
                                            onChange={this.handleOssUserNameChange}
                                            onFocus={this.handleOssUserNameFocus}
                                            placeholder={t('system.title.ur_name')}
                                            readOnly={!isAutoCompleteOssName}
                                          />
                                          <div className={cx('error', { show: ossUserNameError })}>
                                            {t('modal.error.user_name_required')}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="setting_contnet_wrap">
                                      <div className="left_content">
                                        <h3 className="setting_content_title">{t('modal.title.password')}</h3>
                                        <div className="setting_content">
                                          <input
                                            type="password"
                                            name="pass"
                                            style={{ width: '50%' }}
                                            value={ossPassword}
                                            onChange={this.handleOssPWChange}
                                            onFocus={this.handleOssPWFocus}
                                            placeholder={t('modal.title.password')}
                                            readOnly={!isAutoCompleteOssPass}
                                          />
                                          <div className={cx('error', { show: ossPasswordError })}>
                                            {t('modal.error.password_required')}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="setting_contnet_wrap" style={{ marginTop: '0' }}>
                        <div className="setting_content">
                          <div className="right_box">
                            <a
                              className="update"
                              onClick={this.onSubmitWithOss}
                            >
                              {t('modal.button.save')}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )
          }
          {
            systemObj && systemObj.oss_db && (systemObj.camp || systemObj.job_count) ? (
              <div className="line" />
            ) : null
          }
          {
            systemObj && systemObj.camp && (
              <div className="setting_small_box setting_small_box_2">
                <h2 className="page_title">
                  {t('system.title.camp_settings')}
                  {isCampGlobalErrorLoading ? <span className="error">{campErrorMsg}</span> : null}
                </h2>
                {renderCampIfReady(
                  <div>
                    <div className="setting_contnets" style={{ marginBottom: '35px' }}>
                      <div className="setting_contnet_wrap">
                        <div className="custom_content">
                          <h3 className="setting_content_title">{t('system.title.connect_to_camp')}</h3>
                          <div className="setting_content">
                            <div className="small_box_3" style={{ width: '440px' }}>
                              <div className="switch">
                                <a
                                  className={cx({ checked: selectedCampDB === 'default' })}
                                  onClick={this.handleCampTabChange}
                                >
                                  {t('system.title.default')}
                                </a>
                                <a
                                  className={cx({ checked: selectedCampDB === 'custom' })}
                                  onClick={this.handleCampTabChange}
                                >
                                  {t('system.title.custom_camp')}
                                </a>
                              </div>
                            </div>
                          </div>
                          {
                            selectedCampDB === 'default'
                            && (
                              <div className="" style={{ width: '100%', display: 'inline-block' }}>
                                <p className="text">{t('system.title.camp_clarity_system')}</p>
                              </div>
                            )
                          }
                          {
                            selectedCampDB === 'custom'
                            && (
                              <div className="" style={{ width: '100%', display: 'inline-block' }}>
                                <p className="text">{t('system.title.user_defined_camp')}</p>
                              </div>
                            )
                          }
                        </div>
                      </div>
                      <div className="setting_contnet_wrap">
                        <div className="custom_content">
                          {renderCampIfReadyDetailElement(
                            <div>
                              {
                                selectedCampDB === 'custom'
                                && (
                                  <div>
                                    <div className="setting_contnet_wrap">
                                      <div className="left_content">
                                        <h3 className="setting_content_title">{t('modal.title.host')}</h3>
                                        <div className="setting_content">
                                          <select style={{ width: '15%' }} value={campScheme} onChange={this.handleCampSchemeChange}>
                                            <option value="http">http</option>
                                            <option value="https">https</option>
                                          </select>
                                          <input
                                            type="text"
                                            style={{ width: '50%' }}
                                            value={customCampHost}
                                            onFocus={this.handleCampCustomHostFocus}
                                            onChange={this.handleCampCustomHostChange}
                                            placeholder={`${t('system.list.example')} 127.0.0.1`}
                                          />
                                          {
                                            isCustomCampHostFocus && !customCampHostError ? (
                                              <div className={cx('error', { show: !customCampHostError })} style={{ color: '#7434fe' }}>
                                                {t('system.message.host_local_network')}
                                              </div>
                                            ) : (
                                              <div className={cx('error', { show: customCampHostError })}>
                                                {t('modal.error.host_is_required')}
                                              </div>
                                            )
                                          }
                                        </div>
                                      </div>
                                      <div className="right_content">
                                        <h3 className="setting_content_title">{t('modal.title.port')}</h3>
                                        <div className="setting_content">
                                          <input
                                            type="text"
                                            style={{ width: '50%' }}
                                            value={campPort}
                                            onChange={this.handleCampPortChange}
                                            placeholder={`${t('system.list.example')} 8008`}
                                          />
                                          <div className={cx('error', { show: campPortError })}>
                                            {t('modal.error.port_required')}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="setting_contnet_wrap" style={{ marginTop: '0' }}>
                        <div className="setting_content">
                          <div className="right_box">
                            <a
                              className="update"
                              onClick={this.onSubmitWithCamp}
                            >
                              {t('modal.button.save')}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )
          }
          {
            systemObj && systemObj.camp && systemObj.job_count ? (
              <div className="line" />
            ) : null
          }
          {
            systemObj && systemObj.job_count && (
              <div className="setting_small_box setting_small_box_2">
                <h2 className="page_title">
                  {t('system.title.job_settings')}
                  {isJobCountGlobalErrorLoading ? <span className="error">{jobCountErrorMsg}</span> : null}
                </h2>
                {renderJobCountIfReady(
                  <div>
                    <div className="setting_contnets" style={{ marginBottom: '35px' }}>
                      <div className="setting_contnet_wrap">
                        <div className="custom_content">
                          <div className="setting_contnet_wrap">
                            <div className="left_content">
                              <h3 className="setting_content_title">{t('system.title.job_count')}</h3>
                              <div className="setting_content">
                                <select value={jobCount} onChange={this.handleJobCountChange}>
                                  <option value="1">1</option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                  <option value="5">5</option>
                                  <option value="6">6</option>
                                  <option value="7">7</option>
                                  <option value="8">8</option>
                                </select>
                                <div className="" style={{ width: '100%', display: 'inline-block' }}>
                                  <p className="text" style={{ fontSize: '10px' }}>{t('system.message.change_job_setting_memory')}</p>
                                </div>
                                {
                                  !jobCountError
                                  && (
                                    <div className={cx('error', { show: jobCountError })}>
                                      {t('system.message.job_count_error')}
                                    </div>
                                  )
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="setting_contnet_wrap" style={{ marginTop: '0' }}>
                        <div className="setting_content">
                          <div className="right_box">
                            <a
                              className="update"
                              onClick={this.onSubmitWithJobCount}
                            >
                              {t('modal.button.save')}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )
          }
        </div>
        <Modal
          open={this.state.isOpenModal}
          //onClose={this.closeModal}
        >
          {
            isModalLoading ? <ClarLoader />
              : (
                <div className="modal_popup_wrap confirm_wrap">
                  <div className="modal_popup_box confirm_box">
                    <div className="modal_popup confirm">
                      <h2 className="title">{this.modalAction}</h2>
                      <p className="text">{this.modalBody}</p>
                      {
                        isModalErrorLoading
                    && (
                      <p className="small_text">
                        {this.modalSubBody}
                      </p>
                    )
                      }
                      {
                        isModalErrorLoading ? (
                          <div className="button_wrap">
                            <a onClick={this.closeModal} className="center_button">
                              {t('modal.button.ok')}
                            </a>
                          </div>
                        ) : (
                          <div className="button_wrap">
                            <a onClick={this.closeModal} className="left_button">
                              {t('modal.button.no')}
                            </a>
                            <a onClick={this.setUserDBSettings} className="right_button">
                              {t('modal.button.yes')}
                            </a>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              )
          }
        </Modal>
        <Modal
          open={this.state.isOpenOssModal}
          //onClose={this.closeModal}
        >
          {
            isOssModalLoading ? <ClarLoader />
              : (
                <div className="modal_popup_wrap confirm_wrap">
                  <div className="modal_popup_box confirm_box">
                    <div className="modal_popup confirm">
                      <h2 className="title">{this.modalAction}</h2>
                      <p className="text">{this.modalBody}</p>
                      {
                        isOssModalErrorLoading
                    && (
                      <p className="small_text">
                        {this.modalSubBody}
                      </p>
                    )
                      }
                      {
                        isOssModalErrorLoading ? (
                          <div className="button_wrap">
                            <a onClick={this.closeModal} className="center_button">
                              {t('modal.button.ok')}
                            </a>
                          </div>
                        ) : (
                          <div className="button_wrap">
                            <a onClick={this.closeModal} className="left_button">
                              {t('modal.button.no')}
                            </a>
                            <a onClick={this.setOssDBSettings} className="right_button">
                              {t('modal.button.yes')}
                            </a>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              )
          }
        </Modal>
        <Modal
          open={this.state.isOpenCampModal}
          //onClose={this.closeModal}
        >
          {
            isCampModalLoading ? <ClarLoader />
              : (
                <div className="modal_popup_wrap confirm_wrap">
                  <div className="modal_popup_box confirm_box">
                    <div className="modal_popup confirm">
                      <h2 className="title">{this.modalAction}</h2>
                      <p className="text">{this.modalBody}</p>
                      {
                        isCampModalErrorLoading
                    && (
                      <p className="small_text">
                        {this.modalSubBody}
                      </p>
                    )
                      }
                      {
                        isCampModalErrorLoading ? (
                          <div className="button_wrap">
                            <a onClick={this.closeModal} className="center_button">
                              {t('modal.button.ok')}
                            </a>
                          </div>
                        ) : (
                          <div className="button_wrap">
                            <a onClick={this.closeModal} className="left_button">
                              {t('modal.button.no')}
                            </a>
                            <a onClick={this.setCampSettings} className="right_button">
                              {t('modal.button.yes')}
                            </a>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              )
          }
        </Modal>
        <Modal
          open={this.state.isOpenJobModal}
          //onClose={this.closeModal}
        >
          {
            isJobModalLoading ? <ClarLoader />
              : (
                <div className="modal_popup_wrap confirm_wrap">
                  <div className="modal_popup_box confirm_box">
                    <div className="modal_popup confirm">
                      <h2 className="title">{this.modalAction}</h2>
                      <p className="text">{this.modalBody}</p>
                      {
                        isJobModalErrorLoading
                    && (
                      <p className="small_text">
                        {this.modalSubBody}
                      </p>
                    )
                      }
                      {
                        isJobModalErrorLoading ? (
                          <div className="button_wrap">
                            <a onClick={this.closeModal} className="center_button">
                              {t('modal.button.ok')}
                            </a>
                          </div>
                        ) : (
                          <div className="button_wrap">
                            <a onClick={this.closeModal} className="left_button">
                              {t('modal.button.no')}
                            </a>
                            <a onClick={this.setJobCountSettings} className="right_button">
                              {t('modal.button.yes')}
                            </a>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              )
          }
        </Modal>
        <Modal open={this.state.isOpenAlertModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a onClick={this.closeModal} className="center_button">
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(System))));
